module.exports = __webpack_public_path__ + "static/media/480.4fc3bf37.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-insecticide/light/480.png
// module id = 2196
// module chunks = 2